<div class="wrap-inpdate">
    <input [id]="strId" type="date" (focus)="focusIn()" (focusout)="OnChange()" (input)="InpChange()" [placeholder]="PlaceHolder()" (keydown)="remove($event)"
    name="DateInput" class="form-control form-inp-date" [ngClass]="class" [(ngModel)]="strModel" max="9999-12-31" required/>
    <input type="text" class="form-control form-inp-date inp-placeholder" [placeholder]="PlaceHolder()" [ngClass]="{'faded': GetTypeDate()}"/>
</div>